import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {
    Row, Col, Form, Button, ListGroup, ListGroupItem
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import { checkValidations, returnCheckedFormItems, returnTempZoneList, returnTempReportType, returnTempCountryData, returnTempStateData, countryCheck, setMultiSelectData } from './helper';
import { DATE_FORMAT, REQUEST_DATE_FORMAT, DELIVERY_DATE_FORMAT } from '../../../constants';
import moment from 'moment';
import MyAutosuggest from '../../../components/ReusableComponents/AutoSuggest/index';
import MultiSelect from '../../../components/ReusableComponents/MultiSelect/index';
import { getSelectedCountryStates } from '../../../components/Services/action';

class FilterTemplateClass extends Component {
    constructor() {
        super();
        this.state = {
            toDate: null,
            fromDate: null,
            reportTypes: [],
            regions: [],
            ShoWError: false,
            ShowErrorMsg: '',
            selectedCountry: null,
            selectedState: [],
            stateDataList: [],
            value: ''
        }
    }

    hideCreditUsageFilter = () => {
        this.props.hideCreditUsageFilterCallback()
    }
    componentDidUpdate(prevProps) {
        if (this.props.stateList !== prevProps.stateList) {
            this.setState({
                stateListData: setMultiSelectData(this.props.stateList)
            })
        }
    }
    applyCreditUsageFilters = () => {
        let msg = checkValidations(this.state.fromDate, this.state.toDate);

        if (msg === '') {
            this.setState({ ShoWError: false, ShowErrorMsg: '' }, () => {
                let obj = {}
                let tempSelectedCountry = returnTempCountryData(this.state.selectedCountry)
                let tempSelectedState = returnTempStateData(this.state.selectedState);
                if (this.props.applyCreditForm.values != null) {
                    let tempFilterFormValues = returnCheckedFormItems(this.props.applyCreditForm.values);
                    let tempZoneList = returnTempZoneList(tempFilterFormValues, this.props.regionListItems);
                    let tempReportType = returnTempReportType(tempFilterFormValues, this.props.repoortTypeListItems);
                    obj = {
                        fromDate: (this.state.fromDate) ? moment(this.state.fromDate).local().format() : null,
                        toDate: (this.state.toDate) ? moment(this.state.toDate).local().format() : null,
                        reportTypes: tempReportType,
                        regions: tempZoneList,
                        selectedCountry: tempSelectedCountry,
                        selectedState: tempSelectedState
                    }
                } else {
                    obj = {
                        fromDate: moment(this.state.fromDate).format(REQUEST_DATE_FORMAT),
                        toDate: moment(this.state.toDate).format(REQUEST_DATE_FORMAT),
                        reportTypes: [],
                        regions: [],
                        selectedCountry: tempSelectedCountry,
                        selectedState: tempSelectedState
                    }
                }

                this.props.applyCreditUsageFiltersCallBack(obj);
            });
        } else {
            this.setState({ ShoWError: true, ShowErrorMsg: msg });
        }



    }

    handleFromDateChange = (date) => {

        this.setState({ fromDate: date })
    }

    handleToDateChange = (date) => {
        this.setState({ toDate: date })
    }
    resetFilter = () => {
        this.props.reset()
    }
    handleClearFilters = (e) => {
        e.preventDefault();
        this.setState({
            fromDate: null,
            toDate: null,
            value: '',
            selectedCountry: '',
            selectedState: []
        }, () => {
            this.props.reset()
            let obj = {
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                reportTypes: [],
                regions: [],
                selectedCountry: [],
                selectedState: []
            }
            this.props.applyCreditUsageFiltersCallBack(obj);
        })


    }
    searchCallback = (selectedCountry) => {
        this.setState({
            selectedCountry: selectedCountry
        })
        this.props.getStates(selectedCountry.value);
    }
    selectedEntityCallback = (selectedState) => {
        this.setState({
            selectedState: selectedState
        })
    }
    render() {
        const { value } = this.state
        let repoortTypeList;
        let countryCheckFlag = countryCheck(this.state.selectedCountry);
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        };

        repoortTypeList = this.props.repoortTypeListItems.map((p, index) => {
            return (
                <ListGroupItem key={p.id}>
                    <div className="custom-control custom-checkbox">
                        <Field type="checkbox" component="input" className="custom-control-input m-0" name={p.productName} id={p.productName} />
                        <label className="custom-control-label" htmlFor={p.productName}>{p.productName}</label>
                    </div>
                </ListGroupItem>
            )
        })



        let regionList = this.props.regionListItems.map((p, index) => {
            return (
                <ListGroupItem key={p.id}>
                    <div className="custom-control custom-checkbox">
                        <Field type="checkbox" component="input" className="custom-control-input m-0" name={p.name} id={p.name} />
                        <label className="custom-control-label" htmlFor={p.name}>{p.name}</label>
                    </div>
                </ListGroupItem>
            )
        })
        return (
            <Form>
                <Row noGutters className="mb-3">
                    <Col sm="6" className="filter-category py-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between">Report Type<i className="icon-plus d-sm-none"></i></span>
                        <ListGroup className="filter-options">
                            {repoortTypeList}
                        </ListGroup>
                    </Col>
                    <Col sm="6" className="filter-category py-3 p-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex justify-content-between mb-1">Country<i className="icon-minus d-sm-none"></i></span>
                        <MyAutosuggest
                            id='countrySearch'
                            placeholder="Search Country"
                            onChange={this.handleCountryAutocomplete}
                            searchCallback={this.searchCallback}
                            selectedValueCountry={this.state.selectedCountry}
                            inputProps={inputProps}
                            searchType="countrySearch" />
                    </Col>

                    <Col sm="6" className="filter-category py-3 p-3     py-sm-0">
                        {(countryCheckFlag) ?
                            <div>
                                <span className="filter-popover-header-item d-flex justify-content-between mb-1">Region<i className="icon-minus d-sm-none"></i></span>
                                <ListGroup className="filter-options">
                                    {regionList}
                                </ListGroup>
                            </div> :
                            <div>
                                <span className="filter-popover-header-item d-flex justify-content-between mb-1">State<i className="icon-minus d-sm-none"></i></span>
                                <MultiSelect
                                    data={this.state.stateListData}
                                    selected={this.selectedEntityCallback}
                                    selectedValue={this.state.selectedState} />
                            </div>
                        }
                    </Col>


                    <Col sm="6" className="filter-category py-3 py-sm-0">
                        <span className="filter-popover-header-item d-flex  justify-content-between">Delivery Date Range<i className="icon-minus d-sm-none"></i></span>
                        <div className="filter-options">
                            <div className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">From</span> <DatePicker className="mb-2 ml-1" selected={this.state.fromDate} placeholderText={DATE_FORMAT} onChange={this.handleFromDateChange} dateFormat={DELIVERY_DATE_FORMAT} maxDate={moment()}/></div>
                            <div className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">To</span> <DatePicker className="ml-1" selected={this.state.toDate} placeholderText={DATE_FORMAT} onChange={this.handleToDateChange} dateFormat={DELIVERY_DATE_FORMAT} maxDate={moment()}/></div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-between">
                        <Button outline color="primary" onClick={this.hideCreditUsageFilter}>Hide Filters</Button>
                        <div>
                            <Button color="primary" outline className="mr-3" onClick={this.handleClearFilters}>Clear Filters</Button>
                            <Button color="primary" onClick={this.applyCreditUsageFilters}>Apply</Button>
                        </div>

                    </Col>
                </Row>
                <div className={this.state.ShoWError ? "Error" : "Error d-none"} title={this.state.ShowErrorMsg}>{this.state.ShowErrorMsg}</div>
            </Form>
        )
    }
}

FilterTemplateClass = reduxForm({
    form: 'ApplyCreditForm',
    enableReinitialize: true
})(FilterTemplateClass)

const mapStateToProps = (state, ownProps) => ({
    applyCreditForm: state.form.ApplyCreditForm,
    stateList: state.commonReducer.stateListSuccess,

});

const mapDispatchToProps = (dispatch, ownProps) => ({
    getStates: (data) => { dispatch(getSelectedCountryStates(data)) }
});

export default FilterTemplateClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterTemplateClass)